import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingAddressComponent } from './billing-address.component';
import { FormInputModule } from '../dn-form-input/form-input.module';
import { MatMenuModule } from '@angular/material/menu';
import { DnGhostBtnModule } from '../buttons/dn-ghost-btn/dn-ghost-btn.module';
import { DnBtnModule } from '../buttons/dn-btn/dn-btn.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MenuInputModule } from '../menu-input/menu-input.module';

@NgModule({
  declarations: [BillingAddressComponent],
  imports: [CommonModule, FormInputModule, MatMenuModule, DnGhostBtnModule, DnBtnModule, ReactiveFormsModule, MenuInputModule],
  exports: [BillingAddressComponent],
})
export class BillingAddressModule {}
